/**
 * Product Group Variant Picker Component
 * Displays related products based on product_group metafield
 * 
 * Products are found server-side using Liquid (which has access to metafields)
 * and passed to JavaScript via a JSON script tag for rendering.
 */

class ProductGroupVariantPicker extends HTMLElement {
  constructor() {
    super();
    this.products = [];
    this.currentProductId = this.dataset.currentProductId;
    this.currentProductHandle = this.dataset.currentProductHandle;
    this.productGroup = this.dataset.productGroup;
    this.displayMode = this.dataset.displayMode || 'color';
    this.collectionHandle = this.dataset.collectionHandle;
    
    console.log('[ProductGroupVariantPicker] Constructor:', {
      currentProductId: this.currentProductId,
      currentProductHandle: this.currentProductHandle,
      productGroup: this.productGroup,
      displayMode: this.displayMode,
      collectionHandle: this.collectionHandle
    });
  }

  connectedCallback() {
    console.log('[ProductGroupVariantPicker] connectedCallback called');
    console.log('[ProductGroupVariantPicker] Data attributes:', {
      productGroup: this.productGroup,
      currentProductId: this.currentProductId,
      currentProductHandle: this.currentProductHandle
    });
    
    if (!this.productGroup) {
      console.warn('[ProductGroupVariantPicker] No product_group found, skipping');
      return;
    }

    // Get products from JSON script tag (populated by Liquid)
    const productsScript = this.querySelector('script[data-related-products]');
    if (productsScript) {
      try {
        const productsJson = productsScript.textContent.trim();
        console.log('[ProductGroupVariantPicker] Found products JSON:', productsJson);
        this.products = JSON.parse(productsJson);
        console.log('[ProductGroupVariantPicker] Parsed products:', this.products);
        this.renderProducts();
      } catch (error) {
        console.error('[ProductGroupVariantPicker] Error parsing products JSON:', error);
      }
    } else {
      console.warn('[ProductGroupVariantPicker] No products script tag found');
    }
  }

  /**
   * Renders the product options
   */
  renderProducts() {
    console.log('[ProductGroupVariantPicker] renderProducts called with', this.products.length, 'products');
    const containerEl = this.querySelector('[data-container]');
    const optionsEl = this.querySelector('[data-options]');

    console.log('[ProductGroupVariantPicker] Render elements:', {
      containerEl: !!containerEl,
      optionsEl: !!optionsEl
    });

    if (this.products.length === 0) {
      console.warn('[ProductGroupVariantPicker] No products to render');
      if (containerEl) containerEl.style.display = 'none';
      return;
    }

    if (containerEl) {
      containerEl.style.display = 'block';
      console.log('[ProductGroupVariantPicker] Showing container');
    }
    if (optionsEl) {
      optionsEl.innerHTML = '';
      console.log('[ProductGroupVariantPicker] Rendering', this.products.length, 'product options');

      this.products.forEach((product, index) => {
        console.log('[ProductGroupVariantPicker] Rendering product', index + 1, ':', product);
        const isCurrent = product.isCurrent === true || 
                         product.id.toString() === this.currentProductId || 
                         product.handle === this.currentProductHandle;

        const option = document.createElement('button');
        option.type = 'button';
        option.className = `product-group-variant-picker__option product-group-variant-picker__option--${this.displayMode}`;
        option.dataset.current = isCurrent ? 'true' : 'false';
        option.dataset.productHandle = product.handle;
        option.setAttribute('aria-label', product.variantName || product.title);
        option.setAttribute('title', product.variantName || product.title);

        if (this.displayMode === 'color' && product.colorCode) {
          option.style.setProperty('--swatch-color', product.colorCode);
        } else if (this.displayMode === 'image' && product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = product.variantName || product.title;
          img.loading = 'lazy';
          option.appendChild(img);
        } else {
          // Fallback: use color code if available, otherwise show first letter
          if (product.colorCode) {
            option.style.setProperty('--swatch-color', product.colorCode);
          } else {
            option.textContent = (product.variantName || product.title).charAt(0).toUpperCase();
            option.style.setProperty('--swatch-color', '#ccc');
          }
        }

        option.addEventListener('click', () => {
          console.log('[ProductGroupVariantPicker] Clicked on product:', product.handle);
          
          // Scroll to top first
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          
          // Wait a moment for scroll to start, then navigate
          setTimeout(() => {
            window.location.href = product.url;
          }, 50);
        });

        optionsEl.appendChild(option);
        console.log('[ProductGroupVariantPicker] Added option for product:', product.handle);
      });
      
      console.log('[ProductGroupVariantPicker] Finished rendering all options');
    } else {
      console.error('[ProductGroupVariantPicker] optionsEl not found!');
    }
  }

}

if (!customElements.get('product-group-variant-picker')) {
  customElements.define('product-group-variant-picker', ProductGroupVariantPicker);
}

